import FolderIcon from '@mui/icons-material/Folder';
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import { Box, Button, Typography } from '@mui/material';
import { categoryLabel, formatDuration, platformLabel } from './taskFields';
import TaskFold from './TaskFold';
import { CONTENT_TYPE_LABELS, shortName } from './taskUi';

/** What the task is, closed by default. Rows with nothing in them are left out. */
const TaskDetails = ({ task, detail, categories, platforms, onShowFolder }) => {
    const story = detail.post?.postType === 'STORY';
    const rows = [
        ['Type', `${CONTENT_TYPE_LABELS[task.contentType]}${story ? ', Story' : ''}`],
        ['Platform', task.platform && platformLabel(platforms, task.platform)],
        ...(task.redacted
            ? []
            : [
                  ['Category', task.categoryKey && categoryLabel(categories, task.categoryKey)],
                  ['Duration', task.durationSeconds && formatDuration(task.durationSeconds)],
                  ['PM', shortName(task.projectManager)],
                  ['Watchers', task.watchers?.map(shortName).join(', ')],
              ]),
    ].filter(([, value]) => value);
    const inFiles = !task.redacted && task.contentType !== 'POST' && task.contentType !== 'AUDIO' && !task.waitingForFile;
    return (
        <TaskFold label="Details">
            <Box sx={{ display: 'grid', gridTemplateColumns: '96px minmax(0, 1fr)', gap: 0.5, pb: 1 }}>
                {rows.map(([label, value]) => (
                    <Box key={label} sx={{ display: 'contents' }}>
                        <Typography variant="body2" color="text.secondary">
                            {label}
                        </Typography>
                        <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
                            {value}
                        </Typography>
                    </Box>
                ))}
            </Box>
            {inFiles && detail.contentFolderPath && (
                <Button
                    size="small"
                    startIcon={<FolderIcon />}
                    onClick={() => onShowFolder(detail.contentFolderPath)}
                >
                    Show in Files
                </Button>
            )}
            {inFiles && detail.taskFolderPath && (
                <Button
                    size="small"
                    startIcon={<FolderSpecialIcon />}
                    onClick={() => onShowFolder(detail.taskFolderPath)}
                >
                    Old task files ({detail.oldTaskFileCount})
                </Button>
            )}
        </TaskFold>
    );
};

export default TaskDetails;
